import React, { useEffect, useState, useRef } from "react";
import NavBar from "../NavBar/NavBar";
import SideBar from "./SideBar";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getIsMobile,
  setLocalStorageItem,
  setSessionStorageItem,
} from "../../../system";
import {
  roles,
  globalConstants,
  StorageKeys,
  viewPathConstants,
  UserVerificationApprovalStatus,
} from "../../../constants";
import BecomeInstructorPractitioner from "../Links/BecomeInstructorPractitioner";
import { useScreenWidth } from "../../hooks/windowResize";
import { authActions, systemActions } from "../../../redux/actions";

const sidebarOpenBreakpoint = globalConstants.SCREEN_BREAKPOINTS.lg;
const sidebarCollapsedBreakpoint = globalConstants.SCREEN_BREAKPOINTS.md;

function SideBarContainer(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const mainContainerRef = useRef(null);
  const userData = useSelector((state) => state.LoginReducer.UserData);
  const systemReducer = useSelector((state) => state.systemReducer);

  const [screenWidth] = useScreenWidth();
  const [sidebarOpen, setSideBarOpen] = useState(
    !getIsMobile(sidebarOpenBreakpoint)
  );
  const [sidebarCollapsed, setSideBarCollapsed] = useState(
    !getIsMobile(sidebarCollapsedBreakpoint)
  );
  const handleViewSidebar = () => {
    setSideBarOpen(!sidebarOpen);
  };

  useEffect(() => {
    setSideBarOpen(!getIsMobile(sidebarOpenBreakpoint));
    setSideBarCollapsed(!getIsMobile(sidebarCollapsedBreakpoint));
    // eslint-disable-next-line
  }, [screenWidth]);

  const handleToggleSailorProfile = (value) => {
    dispatch(systemActions.toggleSailorProfile(value));
  };

  //Save active role in localStorage
  const handleProfileToggle = () => {
    handleToggleSailorProfile(!systemReducer.isSailorProfile);
    const activeRole = systemReducer.isSailorProfile
      ? roles.Instructor
      : roles.Practioner;
    setLocalStorageItem(StorageKeys.activeRole, activeRole);
    dispatch(authActions.setActiveProfile(activeRole));
    if (activeRole == roles.Instructor) {
      navigate(viewPathConstants.PROFILE);
    }
    if (activeRole == roles.Practioner) {
      navigate(viewPathConstants.PROFILE);
    }
    if (
      activeRole === roles.Instructor &&
      userData?.instructorStatus === UserVerificationApprovalStatus.Disabled
    ) {
      navigate(viewPathConstants.DISABLED_INSTRUCTOR);
    }
  };

  useEffect(() => {
    mainContainerRef.current.scrollTop = 0;
    // eslint-disable-next-line
  }, [window.location.href]);

  return (
    <div className="sidebarcontainerDiv">
      <NavBar
        hideProfileIcon={false}
        handleViewSidebar={handleViewSidebar}
        showMobileLogo={sidebarCollapsed && !sidebarOpen}
      ></NavBar>
      <section className="row mainContainerDashboard w-100">
        <section
          id="sidebar"
          className={
            "col-2 v1 sidebar justify-content-start " +
            (sidebarOpen ? "open" : sidebarCollapsed ? "open collapsed" : "")
          }
        >
          <SideBar
            setSideBarOpen={
              getIsMobile(sidebarOpenBreakpoint) ? setSideBarOpen : null
            }
            handleProfileToggle={handleProfileToggle}
            setIsChecked={handleToggleSailorProfile}
            isChecked={systemReducer.isSailorProfile}
            sidebarOpen={sidebarOpen}
            sidebarCollapsed={sidebarCollapsed}
          ></SideBar>
        </section>
        <main
          ref={mainContainerRef}
          className={`main-container ${sidebarOpen ? " col" : "col-12"} `}
          id="main-container"
        >
          {<BecomeInstructorPractitioner />}
          {props.element}
        </main>
      </section>
    </div>
  );
}

export default SideBarContainer;
